export * from './allocation-view-register-new-truck-action.state';
export * from './allocation-view-register-new-truck-action.facade';
